import { useEffect, useRef } from "react";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import styles from "./QrModal.module.scss";
import SmallLink from "@components/global/new/SmallLink/SmallLink";
import Copy from "@components/global/new/Copy/Copy";
import Icon from "@components/global/new/Icon/Icon";

import tg from "@assets/icons/telegram.svg";
import Field from "@components/global/new/Field/FieldEx";
interface QrModalPropsI extends CommonModalPropsI {
  qr: string;
  tg_code: string;
  telegram_bot_link: string;
}

function QrModal({
  qr,
  tg_code,
  telegram_bot_link,
  formatMessage,
  ...props
}: QrModalPropsI) {
  const ref = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "auto";
    }
  }, [ref]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <h3>{formatMessage({ id: "modal.qr.title" })}</h3>
      <img src={`data:image/png;base64, ${qr}`} alt='watt manor' />
      <Field
        type='text'
        readOnly
        disabled
        className={styles.code}
        defaultValue={tg_code}
        copy
      />
      {/* {tg_code} */}
      {/* <Copy text={tg_code} /> */}

      <div className={styles.bottom}>
        {formatMessage({ id: "modal.qr.bottom" })}{" "}
        <div className={styles.bot}>
          {/* <Icon src={tg} disHover /> */}
          <a href={telegram_bot_link} target='_blank' rel='noreferrer'>
            <Icon src={tg} noHover /> @WattManorBot
          </a>
        </div>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.QR_MODAL, QrModal);
